import React, {Component} from 'react'
import {connect} from 'react-redux'
import { QuizzFinalStyle } from './../../../../styles'
import { fetchQuestion} from './../../../../services/ApiController'
import { editChallenge } from './../../../../store/actions/Session'

const ROLE = [
  'ROLE_ZONE_MANAGER',
  'ROLE_MANAGER',
  'ROLE_ADMIN',
  'ROLE_SUPER_ADMIN',
]


class Final extends Component {
  state = {
    result:{}
  }

  componentDidMount() {
    this.update()
  }

  componentWillReceiveProps({result}) {
    if (result !== result) this.update()
  }

  update = () => {
    if (!this.props.alreadyPlayed) this.props.editChallenge()
  }

  render () {
    const {name, role, alreadyPlayed, result} = this.props
    return (
      <div className={`quizz quizz-final ${QuizzFinalStyle} flex`}>
        <div className="quizz-final-middle flex">
          <div className="quizz-final-title quizz-up">
            Test completed
          </div>
          <div className="quizz-final-name quizz-up"> Congratulations {name} </div>
          <div className="quizz-final-score quizz-red"> Score {result.result} pts</div>
          {
             ROLE.indexOf(role) !== -1 && <p> Your score cannot be taken into account </p>
          }
          {
            alreadyPlayed && <p>You can practice again but your score cannot be taken into account</p>
          }
        </div>
        <div className="quizz-final-next">
          NEXT SESSION : {result.next_session}
        </div>
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    role: Session.role,
  }),
  dispatch => ({
    editChallenge: () => dispatch(editChallenge())
  })
)(Final)



// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Quizz/Final.js